import React from "react";
import "./ExamPasswordDialog.css";
import {  Button, Form, InputGroup } from "react-bootstrap";

import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";
import QrCodeScanner from "../../../../components/qrCodeScanner/QrCodeScanner";
import ValidationHelper from "../../../../helpers/ValidationHelper";

class ExamPasswordDialog extends React.Component {
  constructor(props) {
    super(props);

    this.validationDefinition = {
      examPINCode: {
        defaultValue: "",
        initValid: true,
        rule: ValidationHelper.isPinCode
      },
      examPassword: {
        defaultValue: "",
        initValid: true,
        rule: (value) => ValidationHelper.isString(value) && value.length > 0
      }
    };

    this.isStarting = false;

    this.state = {
      showPassword: false,
      showPINCode: false,
      showVideo: false,
      scannerError: "",
      validation: ValidationHelper.getValidation(this.validationDefinition)
    };

    this.examPasswordForm = React.createRef();
    this.onSubmit = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.handleScanStart = this.handleScanStart.bind(this);
    this.handleScanResult = this.handleScanResult.bind(this);
    this.handleScanError = this.handleScanError.bind(this);
    this.scannerRef = React.createRef();
    this.modalRef = React.createRef();
  }

  async onSubmit() {
    if (this.state.validation._isValid && !this.isStarting) {
      this.isStarting = true;
      try {
        const validatedData = ValidationHelper.getData(this.state.validation);
        await this.props.onSubmit(this.props.examination, validatedData.examPINCode, validatedData.examPassword);
      }catch (err){}
      this.isStarting = false;
    }
  }

  handleKeyUp(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.onSubmit();
    }
  }

  handleScanStart(callback) {
    this.setState(
      {
        showVideo: true,
        scannerError: ""
      }, callback);
  }

  handleScanValidation(res){
    return ValidationHelper.isPinCode(res.split(":")[1]);
  }

  handleScanResult(res) {
    let code = res.split(":")[1];
    this.handleChange({target: {
        name: "examPINCode",
        value: code
      }})
    this.setState({ showVideo: false}, this.onSubmit);
  }

  handleScanError(err) {
    this.setState({
      scannerError: err
    });
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation)
    });
  }

  render() {
    const { t } = this.props;
    const examinationPINCode = this.props.examination
    && (
        this.props.examination.examination.securityLevel === 2
        || this.props.examination.examination.securityLevel === 4
        || this.props.examination.examination.securityLevel === 6) ? (
        <Form.Group controlId="formExamPassword">
            <Form.Label>
                {t("ExaminationAccess.ExamPasswordDialog.Form.ExamPINCode")}
            </Form.Label>
            <InputGroup>
                <Form.Control
                    type={this.state.showPINCode ? "text" : "password"}

                    isInvalid={!this.state.validation.examPINCode.isValid}
                    placeholder={
                        this.state.showPINCode
                            ? t(
                                "ExaminationAccess.ExamPasswordDialog.Form.ExamPINCodePlaceholderClear"
                            )
                            : t(
                                "ExaminationAccess.ExamPasswordDialog.Form.ExamPINCodePlaceholder"
                            )
                    }
                    value={this.state.validation.examPINCode.value}
                    required
                    onChange={s =>
                        this.handleChange({
                            target: {
                                name: "examPINCode",
                                value: s.target.value
                            }
                        })
                    }
                />
                <InputGroup.Append>
                    <Button
                        className={
                            this.state.showPINCode
                                ? "btn-green"
                                : "btn-green-inactive"
                        }
                        onClick={() =>
                            this.setState({ showPINCode: !this.state.showPINCode })
                        }
                    >
                        <FontAwesomeIcon icon={faEye} />
                    </Button>
                    <QrCodeScanner
                        className="btn btn-black"
                        content={""}
                        previewRef={this.scannerRef}
                        validator={this.handleScanValidation}
                        onScannerStart={this.handleScanStart}
                        onScannerError={this.handleScanError}
                        onScannerResult={this.handleScanResult} />
                </InputGroup.Append>
                <Form.Control.Feedback type="invalid">
                    {t("ExaminationAccess.ExamPasswordDialog.ValidationError.PinInvalid")}
                </Form.Control.Feedback>
            </InputGroup>
        </Form.Group>
    ) : "";
    const examinationPassword = this.props.examination
    && this.props.examination.examination.securityLevel !== 6
    && this.props.examination.examination.hasPassword ? (
        <Form.Group controlId="formExamPassword" className="mb-2">
          <Form.Label>
            {t("ExaminationAccess.ExamPasswordDialog.Form.ExamPassword")}
          </Form.Label>
          <InputGroup>
            <Form.Control
                type={this.state.showPassword ? "text" : "password"}

                isInvalid={!this.state.validation.examPassword.isValid}
                placeholder={
                  this.state.showPassword
                      ? t(
                          "ExaminationAccess.ExamPasswordDialog.Form.ExamPasswordPlaceholderClear"
                      )
                      : t(
                          "ExaminationAccess.ExamPasswordDialog.Form.ExamPasswordPlaceholder"
                      )
                }
                value={this.state.validation.examPassword.value}
                required
                onChange={s =>
                    this.handleChange({
                      target: {
                        name: "examPassword",
                        value: s.target.value
                      }
                    })
                }
            />
            <InputGroup.Append>
              <Button
                  className={
                    this.state.showPassword
                        ? "btn-green"
                        : "btn-green-inactive"
                  }
                  onClick={() =>
                      this.setState({ showPassword: !this.state.showPassword })
                  }
              >
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </InputGroup.Append>
            <Form.Control.Feedback type="invalid">
              {t("ExaminationAccess.ExamPasswordDialog.ValidationError.PasswordInvalid")}
            </Form.Control.Feedback>
          </InputGroup>
        </Form.Group>
    ) : "";
    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.props.onHide}
        rightButtonCallback={this.onSubmit}
        onKeyUp={this.handleKeyUp}
        innerRef={this.modalRef}
        title={t("ExaminationAccess.ExamPasswordDialog.Title")}
        rightButtonText={t("ExaminationAccess.ExamPasswordDialog.Form.SubmitButton")}
        leftButtonText={t("ExaminationAccess.ExamPasswordDialog.Form.CancelButton")}
        rightButtonVariant="green"
        leftButtonVariant="black"
        leftButtonCallback={this.props.onHide}
        dialogApiError={this.props.dialogApiError}
        body={(
          <div>
            <Form ref={this.examPasswordForm} onSubmit={event => event.preventDefault()}>
                {examinationPassword}
                {examinationPINCode}
            </Form>
            {this.state.showVideo && <div style={{textAlign: "center"}}>
              <video ref={this.scannerRef} width={465} />
            </div>}
          </div>
        )}
      />
    );
  }
}

export default withTranslation()(ExamPasswordDialog);
